import React, { useContext, useState } from 'react'
import EditLeaguesAPI from '../components/Admin/LeaguesAPI/EditLeaguesAPI';
import LeaguesAPI from '../components/Admin/LeaguesAPI/LeaguesAPI';

import UserFavoritedLeaguesAPI from '../components/Profile/UserFavoritedLeaguesAPI'
import Countries from '../components/Public/FootballAPI/Country/Countries';
import AllLeagues from '../components/Public/FootballAPI/League/AllLeagues';
import TopLeagues from '../components/Public/FootballAPI/League/TopLeagues'
import SearchTeams from '../components/Public/FootballAPI/Search/SearchTeams';
import StateContext from '../StateContext'

function FootballAPIPage() {

    const appState = useContext(StateContext);

    const [activeItem, setActiveItem] = useState("1");
    const [showLeagues, setShowLeagues] = useState(false)

    const [topLeaguesFB, setTopLeaguesFB] = useState([])

    const [showAdmin, setShowAdmin] = useState(false)

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    function toggleLeagues() {
        if (showLeagues) {
            setShowLeagues(false)
        } else {
            setShowLeagues(true)
        }
    }

    function toggleAdmin() {
        if (showAdmin) {
            setShowAdmin(false)
        } else {
            setShowAdmin(true)
        }
    }

    return (
        <div>

            <div className="row no-gutters">
                <div className="col-4">
                    <button onClick={() => toggle("1")} className={`btn btn-white btn-block ${activeItem === "1" && "active underline-active"}`}>Ligaer</button>
                </div>
                <div className="col-4">
                    <button onClick={() => toggle("2")} className={`btn btn-white btn-block ${activeItem === "2" && "active"}`}>Nasjoner</button>
                </div>
                <div className="col-4">
                    <button onClick={() => toggle("3")} className={`btn btn-white btn-block ${activeItem === "3" && "active"}`}>Søk</button>
                </div>
            </div>

            
            {activeItem === "1" && (
                <div className="container">
                    {appState.loggedIn && (
                        <React.Fragment>
                            
                            <UserFavoritedLeaguesAPI />
                            {appState.loggedIn && (
                                <React.Fragment>
                                    <h2 className="my-4">Rediger ligaer</h2>
                                    <div className="text-center">
                                        <div className="transparent" onClick={toggleAdmin}>
                                            {showAdmin ? <i className="far fa-times-circle text-primary fa-4x"></i> : <i className="fas fa-4x fa-plus-circle text-primary"></i>}
                                        </div>
                                    </div>
                                    
                                    {showAdmin && (
                                        <>
                                            <LeaguesAPI />
                                            <EditLeaguesAPI />
                                        </>
                                    )}
                                </React.Fragment>
                            )}

                        </React.Fragment>
                    )}
                    <div className="card card-header mt-4">Toppligaer</div>
                    <TopLeagues topLeaguesFB={topLeaguesFB} setTopLeaguesFB={setTopLeaguesFB} />

                    <div className="card card-header mt-4" onClick={toggleLeagues}>Alle</div>
                    {showLeagues && <AllLeagues topLeaguesFB={topLeaguesFB} />}
                </div>
            )}
            {activeItem === "2" && (<Countries />)}
            {activeItem === "3" && (
                <SearchTeams />
            )}

        </div>
    )

}
export default FootballAPIPage